import moment from 'moment';
import React from 'react'
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { KTIcon, toAbsoluteUrl } from '../../_metronic/helpers';
import { useTranslation } from "react-i18next";
import { formatDateWithDateAndMonthName, FormatInvoiceDecimalNumber, getValueFromResource } from '../../common/timeLiveFunction';
const AccountInvoiceFormNavBar = () => {
    const { cultureInfoName, decimalPlaces } = useAppSelector((state) => state.globalState)
    const { subTotal, discount, taxCode1, taxCode2, grandTotal, dueDate, masterCurrencyCode } = useAppSelector((state) => state.invoiceBilling);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    return (
        <div className="row col-md-12 col-sm-12 col-xs-12 navBarParentDiv mt-5">
            <div className='col-md-2 col-sm-2 col-xs-12' style={{ paddingLeft: 0 }}>
                <div className='cardInfoShadow'>
                    <div className='tsNavBarInnerBoxParent'>
                        <div className='tsNavBarInnerBoxFirstSection'>
                            <div className='tsNavBarInnerBoxFirstInner' />
                            <div className='symbol symbol-48px me-3'>
                                <img
                                    src={toAbsoluteUrl('/media/svg/customSVG/Total.svg')}
                                />
                            </div>
                        </div>
                        <div className='tsNavBarInnerBoxSecondSection'>
                            {<span className="fw-bold d-block fs-3 tsNavBarInfoText">{masterCurrencyCode + ' ' + (FormatInvoiceDecimalNumber(cultureInfoName.toString(), subTotal, decimalPlaces))}</span>}
                            <a className="text-uppercase tsNavBarInfoLabel">
                                {/* {t('Sub Total')} */}
                                {getValueFromResource('Sub Total',dispatch, t)}
                                </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-md-2 col-sm-2 col-xs-12'>
                <div className='cardInfoShadow'>
                    <div className='tsNavBarInnerBoxParent'>
                        <div className='tsNavBarInnerBoxFirstSection'>
                            <div className='tsNavBarInnerBoxFirstInner' />
                            <div className='symbol symbol-48px me-3'>
                                <img
                                    src={toAbsoluteUrl('/media/svg/customSVG/Discount.svg')}
                                />
                            </div>
                        </div>
                        <div className='tsNavBarInnerBoxSecondSection'>
                            <span className="fw-bold d-block fs-3 tsNavBarInfoText">{masterCurrencyCode + ' ' + (discount != null ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), discount, decimalPlaces) : FormatInvoiceDecimalNumber(cultureInfoName.toString(), 0, decimalPlaces))}</span>
                            <a className="text-uppercase tsNavBarInfoLabel">
                                {/* {t('Discount Amount')} */}
                                {getValueFromResource('Discount Amount',dispatch, t)}
                                </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-md-2 col-sm-2 col-xs-12'>
                <div className='cardInfoShadow'>
                    <div className='tsNavBarInnerBoxParent'>
                        <div className='tsNavBarInnerBoxFirstSection'>
                            <div className='tsNavBarInnerBoxFirstInner' />
                            <div className='symbol symbol-48px me-3'>
                                <img
                                    src={toAbsoluteUrl('/media/svg/customSVG/Tax.svg')}
                                />
                            </div>
                        </div>
                        <div className='tsNavBarInnerBoxSecondSection'>
                            <span className="fw-bold d-block fs-3 tsNavBarInfoText">{FormatInvoiceDecimalNumber(cultureInfoName.toString(), taxCode1, decimalPlaces)}</span>
                            <a className="text-uppercase tsNavBarInfoLabel">
                                {/* {t('Tax 1')} */}
                                {getValueFromResource('Tax 1',dispatch, t)}
                                </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-md-2 col-sm-2 col-xs-12'>
                <div className='cardInfoShadow'>
                    <div className='tsNavBarInnerBoxParent'>
                        <div className='tsNavBarInnerBoxFirstSection'>
                            <div className='tsNavBarInnerBoxFirstInner' />
                            <div className='symbol symbol-48px me-3'>
                                <img
                                    src={toAbsoluteUrl('/media/svg/customSVG/Tax.svg')}
                                />
                            </div>
                        </div>
                        <div className='tsNavBarInnerBoxSecondSection'>
                            <span className="fw-bold d-block fs-3 tsNavBarInfoText">{FormatInvoiceDecimalNumber(cultureInfoName.toString(), taxCode2, decimalPlaces)}</span>
                            <a className="text-uppercase tsNavBarInfoLabel">
                                {/* {t('Tax 2')} */}
                                {getValueFromResource('Tax 2',dispatch, t)}
                                </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-md-2 col-sm-2 col-xs-12'>
                <div className='cardInfoShadow'>
                    <div className='tsNavBarInnerBoxParent'>
                        <div className='tsNavBarInnerBoxFirstSection'>
                            <div className='tsNavBarInnerBoxFirstInner' />
                            <div className='symbol symbol-48px me-3'>
                                <img
                                    src={toAbsoluteUrl('/media/svg/customSVG/GrandTotal.svg')}
                                />
                            </div>
                        </div>
                        <div className='tsNavBarInnerBoxSecondSection'>
                            <span className="fw-bold d-block fs-3 tsNavBarInfoText">{masterCurrencyCode + ' ' + FormatInvoiceDecimalNumber(cultureInfoName.toString(), grandTotal, decimalPlaces)}</span>
                            <a className="text-uppercase tsNavBarInfoLabel">
                                {/* {t('Grand Total')} */}
                                {getValueFromResource('Grand Total',dispatch, t)}
                                </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-md-2 col-sm-2 col-xs-12' style={{ paddingRight: 0 }}>
                <div className='cardInfoShadow'>
                    <div className='tsNavBarInnerBoxParent'>
                        <div className='tsNavBarInnerBoxFirstSection'>
                            <div className='tsNavBarInnerBoxFirstInner' />
                            <div className='symbol symbol-48px me-3'>
                                <img
                                    src={toAbsoluteUrl('/media/svg/customSVG/icon-SubmitDate.svg')}
                                    alt='Worked Today'
                                />
                            </div>
                        </div>
                        <div className='tsNavBarInnerBoxSecondSection'>
                            <span className="fw-bold d-block fs-4 tsNavBarInfoText">{(dueDate != "") ? formatDateWithDateAndMonthName(dueDate, cultureInfoName.toString()) : '-'}</span>
                            <a className="text-uppercase tsNavBarInfoLabel">
                                {/* {t('Due Date')} */}
                                {getValueFromResource('Due Date',dispatch, t)}
                                </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AccountInvoiceFormNavBar